import React from "react";
import {
  Box,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import CommonButtonActionButton from "../common/CommonButtonActionButton";
import CommonDropdown from "../common/CommonDropdown";

const TEST_DESCRIPTIONS = {
  adaptive: {
    title: "Aptitude Test",
    text: "Aptitude Test has 10 categories each having 5 questions.\nIt should take 20 to 25 minutes to complete the test.",
  },
  personality: {
    title: "Self Introspection",
    text: "Self Introspection has 20 questions.\nIt should take 10 to 15 minutes to complete the test.",
  },
  general: {
    title: "Help us know you",
    text: "General Test has 12 questions.\nIt should take 5 to 10 minutes to complete the test.",
  },
};

const UserInfoCard = ({
  userInfoToggle,
  onCollapes,
  onNewConversionClick,
  isLoading,
  student = {},
  selectSubject,
  subjectOptions = [],
  handleSubjectChange
}) => {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.down("xs"));

  if (isLoading) return <CircularProgress />;

  const userDetails = [
     { label: "School Name", value: student.school_name || "-" },
              { label: "Board", value: student.board || "-" },
              { label: "Class", value: student.class || "-" },
  ];

  const selectedTestInfo = TEST_DESCRIPTIONS[selectSubject];

  return (
    <div className="chatbot-userinfo-container">
      {/* Common "New Conversation" button */}
      <CommonButtonActionButton
        className="new-conversation-button"
        label="New Conversations"
        startIcon={<Add />}
        onClick={() => onNewConversionClick("new")}
      />

      {/* Avatar & User Info (desktop vs mobile difference) */}
      {userInfoToggle && !isMdScreen ? (
        <>
          <div>
            <img
              src={student.avatar_url || "/assets/images/news/profile-pic.png"}
              className="profile-pic-container"
              alt={student.student_name}
            />
            <Typography className="profile-user-name">{student.student_name}</Typography>
          </div>

          <Box className="user-details">
            {userDetails.map((detail, idx) => (
              <Typography key={idx} variant="body1">
                <strong>{detail.label}:</strong> {detail.value}
              </Typography>
            ))}
          </Box>
        </>
      ) : (
        <Tooltip title="Open Profile" arrow>
          <img
            src={student.avatar || "/assets/images/news/profile-pic.png"}
            className="profile-pic-container"
            alt={student.student_name}
          />
        </Tooltip>
      )}



     {/* Test Instructions */}
{selectedTestInfo && (
  <Box
    p={2}
    sx={{
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      backgroundColor: "#f9fafb", // light gray background
      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    }}
  >
    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
      ℹ️ {selectedTestInfo.title}
    </Typography>
    <Typography variant="body1" whiteSpace="pre-line" sx={{ lineHeight: 1.6 }}>
      {selectedTestInfo.text}
    </Typography>
  </Box>
)}

    </div>
  );
};

export default UserInfoCard;
